import React from 'react';
import { Navigate, NavLink, Outlet } from 'react-router-dom';
import { LogOut, LayoutDashboard, LockKeyhole, ReceiptText, Users, Wallet } from 'lucide-react';
import { Button } from '../ui/Button';
import { useAdminAuth } from '../../context/AdminAuthContext';

const links = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/admin/wallet', label: 'กระเป๋า', icon: Wallet },
  { to: '/admin/draw-locks', label: 'ล็อกผล', icon: LockKeyhole },
  { to: '/admin/bets', label: 'รายการแทง', icon: ReceiptText },
  { to: '/admin/users', label: 'ผู้ใช้ / Sale', icon: Users },
];

export function AdminLayout() {
  const { isAuthenticated, username, logout } = useAdminAuth();
  if (!isAuthenticated) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-red-50/40 to-brand-gold-light/20">
      <header className="border-b border-red-100 bg-white/95">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-4 py-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-brand-gold">
              Mungkorn Admin
            </p>
            <h1 className="text-xl font-bold text-brand-red">ระบบจัดการ</h1>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden text-sm text-gray-600 sm:inline">
              {username || 'admin'}
            </span>
            <Button variant="outline" size="sm" onClick={logout}>
              <LogOut className="h-4 w-4" />
              ออกจากระบบ
            </Button>
          </div>
          <nav className="order-last flex w-full gap-2 overflow-x-auto border-t border-red-50 pt-3">
            {links.map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `inline-flex shrink-0 items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold ${
                    isActive
                      ? 'bg-brand-red text-white'
                      : 'text-gray-600 hover:bg-red-50 hover:text-brand-red'
                  }`
                }
              >
                <Icon className="h-4 w-4" />
                {label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
